import { render, staticRenderFns } from "./GroupItem.vue?vue&type=template&id=0b38b967&scoped=true"
import script from "./GroupItem.vue?vue&type=script&lang=ts"
export * from "./GroupItem.vue?vue&type=script&lang=ts"
import style0 from "./GroupItem.vue?vue&type=style&index=0&id=0b38b967&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b38b967",
  null
  
)

export default component.exports